import React, { Component, PropTypes } from 'react';
import cn from 'classnames';
import moment from 'moment';
import { Row, Col, Alert, Radio, Button, Form, Icon, Input, Select, DatePicker, TimePicker, InputNumber } from 'antd';
import { dateTh, formatDate } from 'utils/formatDate';
import _ from 'lodash';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { getContentDistricts } from 'data/content';

import { editSingleSchedule, editMultipleSchedule, editFlexibleSchedule, getSchedule } from 'data/schedule';
import Editor from 'components/Form/WYSIWYG';
import { formatNumber } from 'utils/formatting';
import Utils from 'utils/utils';
import { formItemLayout, fullFormLayout, halfFormItemLayout, halfForm2ItemLayout } from 'constants/layout';
import classes from '../styles/ScheduleInfo.module.scss';

const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const formatTime = (timeNumber) => {
  return moment(`${timeNumber}`, 'Hmm').format('HH:mm');
};

const defaultStartTime = 900;
const defaultEndTime = 1700;

const FormItem = Form.Item;
const { Option, OptGroup } = Select;
const { TextArea } = Input;

// receive provinces districts

class MasterScheduleInfoTab extends Component {
  // static propTypes = {
  //   schedule: PropTypes.any,
  // };

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      showRejectModal: false,
      isPreview: true,
      isEditPrice: false,
      // districts: props.districts,
    };
  }

  fetchDistricts = async () => {
    const masterSchedule = _.get(this, 'props.classroom.masterSchedule');
    const districts = await getContentDistricts(masterSchedule.province);
    this.setState({ districts });
  };
  fetchSchedule = async () => {
    // console.log(this.props.classroom.masterSchedule);
    const masterScheduleId = _.get(this, 'props.classroom.masterSchedule._id');

    const schedule = await getSchedule(masterScheduleId);
    this.setState({ masterSchedule: schedule });
    this.props.hideLoading();
  };

  componentDidMount = () => {
    this.props.showLoading();
    this.fetchSchedule();
    this.fetchDistricts();
  };

  addMultipleStudentPrice = (e) => {
    e.preventDefault();
    const { getFieldsValue } = this.props.form;
    if (getFieldsValue(['multipleStudentPrices']).multipleStudentPrices) {
      const multipleStudentPrices = [...getFieldsValue(['multipleStudentPrices']).multipleStudentPrices];
      multipleStudentPrices.push({
        title: '',
        price: 0,
        seats: 0,
      });
      this.setState({ multipleStudentPrices });
    } else {
      this.setState({
        multipleStudentPrices: [
          {
            title: '',
            price: 0,
            seats: 0,
          },
        ],
      });
    }
  };
  deleteMultipleStudentPrice = (index) => {
    const { getFieldsValue } = this.props.form;
    const multipleStudentPrices = [...getFieldsValue(['multipleStudentPrices']).multipleStudentPrices];
    multipleStudentPrices.splice(index, 1);
    this.setState({ multipleStudentPrices });
  };

  addAdditionalProduct = (e) => {
    e.preventDefault();
    const additionalProducts = [...this.state.additionalProducts];
    additionalProducts.push({
      title: '',
      description: '',
      price: 0,
    });
    this.setState({ additionalProducts });
  };
  deleteAdditionalProduct = (index) => {
    const additionalProducts = [...this.state.additionalProducts];
    additionalProducts.splice(index, 1);
    this.setState({ additionalProducts });
  };

  handleSubmit(e) {
    e.preventDefault();
    let editFn;
    editFn = editSingleSchedule;

    const schedule = this.state.masterSchedule;

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const newSchedule = _.merge(values, {});
        // const studiedTime = _.get(schedule, 'class.studiedCount');
        let start;
        let end;

        // const startTime = newSchedule.start
        // const startTime = moment()
        // if (_.get(schedule, 'class.classType') === 'multiple') {
        //   start = [];
        //   end = [];
        //   for (let i = 0; i < studiedTime; i++) {
        //     start.push(moment(newSchedule[`start${i}`]).hour(newSchedule.startTime.hours()).minute(newSchedule.startTime.minute()).toDate());
        //     end.push(moment(newSchedule[`start${i}`]).hour(newSchedule.endTime.hours()).minute(newSchedule.endTime.minute()).toDate());
        //   }
        // } else {
        //   start = moment(newSchedule.start0).hour(newSchedule.startTime.hours()).minute(newSchedule.startTime.minute()).toDate();
        //   end = moment(newSchedule.start0).hour(newSchedule.endTime.hours()).minute(newSchedule.endTime.minute()).toDate();
        // }
        // newSchedule.start = start;
        // newSchedule.end = end;
        const masterSchedule = this.state.masterSchedule;
        const slots = [];
        for (let i = 0; i < masterSchedule.slots.length; i++) {
          const slot = {};
          const initMasterSlot = masterSchedule.slots[i];
          console.log(initMasterSlot);
          slot.startTime = moment(values[`start${i}StartTime`]).format('H:mm');
          slot.endTime = moment(values[`start${i}EndTime`]).format('H:mm');
          slot.isDefault = initMasterSlot.isDefault;
          // slot[`start${i}StartTime`]=  moment(slot.startTime, 'Hmm').format('H:mm');
          slots.push(slot);
        }
        newSchedule.slots = slots;
        console.log(newSchedule.slots);
        this.props.showLoading();

        editFn(_.get(schedule, 'class._id'), this.state.masterSchedule._id, newSchedule).then(() => {
          this.fetchSchedule().then(() => {
            this.setState({
              isPreview: true,
            });
            this.props.hideLoading();
          });
          // browserHistory.push('/schedule');
        });

        console.log('Received values of form: ', values);
      } else {
        alert(err);
      }
    });
  }

  handleSubmitPrice = () => {
    let editFn;
    editFn = editSingleSchedule;

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const newSchedule = _.merge(values, {});
        const additionalProducts = [];
        if (values.multipleStudentPrices && values.multipleStudentPrices.length > 0) {
          values.multipleStudentPrices.forEach((optionPrice) => {
            const price = parseInt(optionPrice.price, 10);
            const seats = parseInt(optionPrice.seats, 10);
            additionalProducts.push({
              ...optionPrice,
              seats,
              price: price / seats,
              type: 'inviteFriends',
            });
          });
        }

        if (values.additionalProducts && values.additionalProducts.length > 0) {
          values.additionalProducts.forEach((optionPrice) => {
            const price = parseInt(optionPrice.price, 10);
            additionalProducts.push({
              ...optionPrice,
              price,
              type: 'others',
            });
          });
        }

        if (additionalProducts.length > 0) {
          newSchedule.additionalProducts = additionalProducts;
        } else {
          delete newSchedule.additionalProducts;
        }
        this.props.showLoading();

        editFn(_.get(this.state.masterSchedule, 'class._id'), this.state.masterSchedule._id, newSchedule).then(() => {
          this.fetchSchedule().then(() => {
            this.setState({
              isEditPrice: false,
            });
            this.props.hideLoading();
          });
        });

        console.log('Received values of fodrm: ', values);
      }
    });
  };

  renderPreview() {
    const { provinces } = this.props;

    const schedule = this.state.masterSchedule;
    // const registerDate = moment(schedule.createdAt).format('DD/MM/YYYY');
    const districts = schedule.districts.reduce((result, district) => {
      const stringResult = `${result}${district}, `;
      return stringResult;
    }, '');

    const province = _.find(provinces, { value: schedule.province });
    console.log(provinces);

    const infoLeftData = [
      // { title: 'วันที่สอน', value: formatDate(schedule.start) },
      // { title: 'เวลาที่สอน', value: `${moment(schedule.start).format('HH:mm')} - ${moment(schedule.end).format('HH:mm')}` },
      {
        title: 'รอบเวลาที่เปิดสอน',
        value: `${schedule.slots.reduce((result, slot, i) => {
          return result.concat(`รอบที่ ${i + 1}: ${moment(slot.startTime, 'Hmm').format('HH:mm')} - ${moment(slot.endTime, 'Hmm').format('HH:mm')} ${slot.isDefault ? '(ค่าเริ่มต้น)' : ''}<br/>`);
          // return result;
        }, '')}`,
      },
      { title: 'หมดเขตรับสมัครก่อนถึง (วัน)', value: schedule.numberOfDayBeforeClose },
      { title: 'สถานที่สอน', value: schedule.place.name },
      { title: 'จังหวัด', value: `${_.get(province, 'label') || schedule.province}` },
      { title: 'พื้นที่', value: _.trimEnd(districts, ', ') },
      { title: 'จำนวนที่เปิดรับ', value: `${schedule.studentEnroll} / ${schedule.classCapacity}` },
      { title: 'จำนวน Early bird', value: `${schedule.earlyBirdEnroll} / ${schedule.earlyBirdCapacity}` },
    ];

    const infoFooter = [
      { title: 'ที่อยู่', value: schedule.place.address },
      { title: 'วิธีการเดินทาง', value: schedule.place.direction },
      { title: 'Google maps', value: schedule.place.googleMap },
      { title: 'Remarks', value: schedule.remark },
    ];

    return (
      <div className={cn('')}>
        <Row gutter={12}>
          <Col xs={12}>
            <div className="content">
              <div className="pull-right">
                <div className={'text-right pointer'} onClick={() => this.setState({ isPreview: false })}>
                  <Icon type="edit" /> Edit
                </div>
              </div>
              <div className="bold underline">Schedule Info</div>
              <table>
                <tbody>
                  {infoLeftData.map((row) => (
                    <tr>
                      <td>{row.title}</td>
                      <td>
                        <span dangerouslySetInnerHTML={{ __html: row.value }}></span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Col>
          <Col xs={12}>
            <div className="content">
              <div className="pull-right">
                <div
                  className={'text-right pointer'}
                  onClick={() =>
                    this.setState({
                      isEditPrice: true,
                      multipleStudentPrices: [...schedule.multipleStudentPrices],
                      additionalProducts: [...schedule.additionalProducts],
                    })
                  }
                >
                  <Icon type="edit" /> Edit
                </div>
              </div>
              <div className="bold ">&nbsp;</div>

              <table>
                <thead />
                <tbody>
                  <tr>
                    <td>ราคาปกติ</td>
                    <td>{formatNumber(schedule.price)}</td>
                  </tr>
                  {!(schedule.earlyBirdCapacity === 0 && schedule.earlyBirdEnroll === 0) && (
                    <tr>
                      <td>ราคา Early Bird</td>
                      <td>{`${formatNumber(_.get(schedule, 'earlyBirdPrice'))}`}</td>
                    </tr>
                  )}

                  {schedule.multipleStudentPrices.map((priceOp, i) => (
                    <tr key={i}>
                      <td>{priceOp.title}</td>
                      <td>{formatNumber(priceOp.price)}</td>
                    </tr>
                  ))}
                  {schedule.additionalProducts.map((priceOp, i) => (
                    <tr key={i}>
                      <td>{priceOp.title}</td>
                      <td>{formatNumber(priceOp.price)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col xs={24}>
            <div className="content">
              <table>
                <tbody>
                  {infoFooter.map((row) => (
                    <tr>
                      <td>{row.title}</td>
                      <td className={'dont-break-out'} dangerouslySetInnerHTML={{ __html: row.value }} />
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  renderPreviewItem(title, value) {
    return (
      <Row className={'ant-form-item'}>
        <Col className={cn('form-preview-title bold text-right')} sm={6}>
          <label>{title}: </label>
        </Col>
        <Col className={cn('form-preview-content')} sm={18}>
          <div dangerouslySetInnerHTML={{ __html: value }} />
        </Col>
      </Row>
    );
  }

  addMoreSlot = () => {
    this.setState({
      masterSchedule: {
        ...this.state.masterSchedule,
        slots: [...this.state.masterSchedule.slots, { startTime: defaultStartTime, endTime: defaultEndTime, isDefault: false }],
      },
    });
  };
  removeSlotAtIndex = (i) => {
    const masterSchedule = this.state.masterSchedule;
    this.setState({
      masterSchedule: {
        ...masterSchedule,
        slots: [...masterSchedule.slots.slice(0, i), ...masterSchedule.slots.slice(i + 1)],
      },
    });
  };

  renderEditor() {
    const { getFieldDecorator, getFieldsValue, setFieldsValue } = this.props.form;
    const schedule = this.state.masterSchedule;
    const teachDate = { title: 'วันที่สอน', value: formatDate(schedule.start) };
    const teachTime = { title: 'เวลาที่สอน', value: `${moment(schedule.start).format('HH:mm')} - ${moment(schedule.end).format('HH:mm')}` };
    const registerClosedDate = { title: 'หมดเขตรับสมัคร', value: formatDate(schedule.registerClosedDate) };
    const districts = [];
    const studiedCount = _.get(schedule, 'class.studiedCount') ? _.get(schedule, 'class.studiedCount') : 1;
    const classType = _.get(schedule, 'class.classType');

    this.state.districts.forEach((district) => {
      if (district.disabled) {
        district.subDistricts = [];
        districts.push(district);
      } else if (districts.length > 0) {
        districts[districts.length - 1].subDistricts.push(district);
      }
    });
    const earlybirdCap = getFieldsValue(['earlyBirdCapacity']).earlyBirdCapacity;
    const maxDate = moment().add(6, 'months').startOf('days');
    const minDate = moment().add(1, 'days').startOf('days');
    const startDate = getFieldsValue(['start0']).start0;

    function disabledDate(current) {
      // Can not select days before today and today
      return current && current > startDate.endOf('day');
    }

    const defaultTimeSlot = schedule.slots.reduce((result, value, index) => {
      if (value.isDefault) {
        return index;
      }
      return result;
    }, 0);

    console.log(schedule.slots);

    return (
      <div className={cn('content')}>
        <div className={'text-right pointer red'} onClick={() => this.setState({ isPreview: true })}>
          <Icon type="close" /> Cancel Edit
        </div>
        {
          // this.renderPreviewItem(teachDate.title, teachDate.value)
        }
        {
          // this.renderPreviewItem(teachTime.title, teachTime.value)
        }
        <Form onSubmit={this.handleSubmit}>
          {/* {classType === 'multiple' &&
            schedule.multiple.map((multipleStartDate, i) => {
              return (
                <FormItem {...formItemLayout} hasFeedback label="วันที่เรียน">
                  {getFieldDecorator(`start${i}`, {
                    rules: [
                      {
                        required: true,
                        message: 'Please input วันที่สอน',
                      },
                    ],
                    initialValue: moment(multipleStartDate.start),
                  })(
                    <DatePicker
                      placeholder="วันที่สอน"
                      onChange={(selectedDate) => {
                        if (i === 0) {
                          setFieldsValue({ registerClosedDate: moment(selectedDate) });
                          // setFieldsValue('registerClosedDate', selectedDate);
                        }
                      }}
                      disabledDate={(selectedDate) => {
                        return selectedDate.isBefore(minDate) || selectedDate.isAfter(maxDate);
                      }}
                    />,
                  )}
                </FormItem>
              );
            })} */}
          <div style={{ border: '1px solid #eee', paddingTop: 20, marginBottom: 20, paddingBottom: 20 }}>
            {/* <Radio.Group
              onChange={(value) => {
                const slots = schedule.slots.map((slot, i) => {
                  if (i === value) {
                    return { ...slot, isDefault: true };
                  }
                  return { ...slot, isDefault: false };
                });
                this.setState({ masterSchedule: { ...schedule, defaultTimeSlot: value, slots } });
              }}
              selectedValue={defaultTimeSlot}
            > */}
            {schedule.slots.map((slot, i) => {
              return (
                <div>
                  <FormItem
                    labelCol={{
                      xs: { span: 24 },
                      sm: { span: 24 },
                    }}
                    label={`เวลาที่เริ่ม - จบ รอบที่ ${i + 1}`}
                    style={{ display: 'inline-block', width: '25%' }}
                  ></FormItem>

                  <Radio
                    style={{ marginTop: 10 }}
                    value={i}
                    onClick={(e) => {
                      const value = parseInt(e.target.value);
                      const slots = schedule.slots.map((slot, i) => {
                        if (i === value) {
                          return { ...slot, isDefault: true };
                        }
                        return { ...slot, isDefault: false };
                      });
                      this.setState({ masterSchedule: { ...schedule, defaultTimeSlot: value, slots } });
                    }}
                    checked={i === defaultTimeSlot}
                  ></Radio>

                  <FormItem {...halfFormItemLayout} style={{ display: 'inline-block' }}>
                    {getFieldDecorator(`start${i}StartTime`, {
                      rules: [
                        {
                          required: true,
                          message: 'Please input เวลาที่เริ่ม',
                        },
                      ],
                      initialValue: moment(slot.startTime, 'Hmm'),
                    })(<TimePicker placeholder="เวลาเริ่ม" minuteStep={30} secondStep={60} disabledHours={() => [0, 1, 2, 3, 4, 5]} />)}
                  </FormItem>
                  <span> &nbsp;&nbsp;&nbsp; </span>

                  <FormItem {...halfForm2ItemLayout} style={{ display: 'inline-block' }}>
                    {getFieldDecorator(`start${i}EndTime`, {
                      rules: [
                        {
                          required: true,
                          message: 'Please input เวลาจบ',
                        },
                      ],
                      initialValue: moment(slot.endTime, 'Hmm'),
                    })(<TimePicker placeholder="เวลาจบ" minuteStep={30} secondStep={60} disabledHours={() => [0, 1, 2, 3, 4, 5]} />)}
                  </FormItem>

                  {i > 0 && (
                    <span>
                      <Icon type="close" style={{ color: '#d9534f', marginTop: 13, marginLeft: 10 }} onClick={() => this.removeSlotAtIndex(i)} />
                    </span>
                  )}
                </div>
              );
            })}
            {/* </Radio.Group> */}

            <Row>
              <Col offset={6}>
                <div>
                  <Button type="default" onClick={() => this.addMoreSlot()}>
                    <Icon type="plus" /> เพิ่มรอบ
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
          <FormItem {...formItemLayout} hasFeedback label="หมดเขตรับสมัครก่อนถึง (วัน)">
            {getFieldDecorator('numberOfDayBeforeClose', {
              rules: [
                {
                  required: true,
                  message: 'Please input หมดเขตรับสมัครก่อนถึง (วัน)',
                },
              ],
              initialValue: schedule.numberOfDayBeforeClose,
            })(<InputNumber placeholder="หมดเขตรับสมัครก่อนถึง (วัน)" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="สถานที่สอน">
            {getFieldDecorator('locationName', {
              initialValue: schedule.place.name,
            })(<Input placeholder="Place name" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="จังหวัด">
            {getFieldDecorator('province', {
              initialValue: schedule.province,
            })(
              <Select
                placeholder="Province"
                onChange={async (value) => {
                  const districts = await getContentDistricts(value);
                  this.setState({ districts });
                }}
              >
                {this.props.provinces.map((province) => {
                  return <Option value={province.value}>{province.label}</Option>;
                })}
              </Select>,
            )}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="พื้นที่">
            {getFieldDecorator('districts', {
              initialValue: schedule.districts,
            })(
              <Select
                mode="multiple"
                // style={{ width: '100%' }}

                searchPlaceholder="Subcategories"
                onChange={this.handleChange}
              >
                {districts.map((district) => {
                  return (
                    <OptGroup label={district.label}>
                      {district.subDistricts.map((subDistrict) => (
                        <Option value={subDistrict.value}>{subDistrict.label}</Option>
                      ))}
                    </OptGroup>
                  );
                })}
              </Select>,
            )}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="จำนวนที่เปิดรับ">
            {getFieldDecorator('classCapacity', {
              initialValue: schedule.classCapacity,
            })(<Input placeholder="Capacity" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="จำนวน Early bird ที่เปิดรับ">
            {getFieldDecorator('earlyBirdCapacity', {
              initialValue: schedule.earlyBirdCapacity,
            })(<Input placeholder="Early bird Capacity" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="ที่อยู่">
            {getFieldDecorator('locationAddress', {})(<Editor data={schedule.place.address} hideCounter={true} />)}
          </FormItem>
          <FormItem {...formItemLayout} label="วิธีการเดินทาง">
            {getFieldDecorator('direction', {})(<Editor data={schedule.place.direction} hideCounter={true} />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="Google map">
            {getFieldDecorator('googleMapUrl', {
              initialValue: schedule.place.googleMap,
            })(<Input placeholder="Remark" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="Remark">
            {getFieldDecorator('remark', {
              initialValue: schedule.remark,
            })(<TextArea placeholder="Remark" />)}
          </FormItem>

          <div className={cn(classes.btnContainer, 'text-center')}>
            <Button type="primary" size="large" onClick={this.handleSubmit} loading={this.props.loading}>
              Save
            </Button>
            <Button type="danger" size="large" onClick={() => this.setState({ isPreview: true })}>
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    );
  }

  renderPriceEditor() {
    const { getFieldDecorator, getFieldsValue } = this.props.form;
    const schedule = this.state.masterSchedule;
    const multipleStudentPrices = this.state.multipleStudentPrices;
    const additionalProducts = this.state.additionalProducts;
    const districts = [];
    this.props.districts.forEach((district) => {
      if (district.disabled) {
        district.subDistricts = [];
        districts.push(district);
      } else if (districts.length > 0) {
        districts[districts.length - 1].subDistricts.push(district);
      }
    });
    const earlybirdCap = getFieldsValue(['earlyBirdCapacity']).earlyBirdCapacity;

    return (
      <div className={cn('content')}>
        <div className={'text-right pointer red'} onClick={() => this.setState({ isEditPrice: false })}>
          <Icon type="close" /> Cancel Edit
        </div>
        <Form onSubmit={this.handleSubmitPrice}>
          <FormItem {...formItemLayout} hasFeedback label="ราคาปกติ">
            {getFieldDecorator('price', {
              initialValue: schedule.price,
            })(<InputNumber placeholder="ราคาปกติ" />)}
          </FormItem>
          {
            <FormItem {...formItemLayout} hasFeedback label="ราคา Early Bird">
              {getFieldDecorator('earlyBirdPrice', {
                initialValue: schedule.earlyBirdPrice,
              })(<InputNumber placeholder="ราคา Early Bird" disabled={earlybirdCap === 0 || earlybirdCap === '0'} />)}
            </FormItem>
          }

          <div className="pull-right">
            <Button type="default" onClick={this.addMultipleStudentPrice}>
              <Icon type="plus" /> เพิ่มตัวเลือก
            </Button>
          </div>
          <h2>ชวนเพื่อนมาเรียน</h2>

          <div className={classes.multiplePriceSection}>
            {multipleStudentPrices.map((priceOp, i) => (
              <div className={classes.multiplePriceContainer}>
                <div className={'pull-right pointer red'} onClick={() => this.deleteMultipleStudentPrice(i)}>
                  <Icon type="close" />
                </div>

                <div className={classes.multiplePriceInnerContainer}>
                  <FormItem {...formItemLayout} hasFeedback label={'ชื่อตัวเลือก'} className={classes.multipleCount}>
                    {getFieldDecorator(`multipleStudentPrices[${i}].title`, {
                      initialValue: priceOp.title,
                      required: true,
                    })(<Input placeholder="ชื่อตัวเลือก" />)}
                  </FormItem>
                  <FormItem {...formItemLayout} hasFeedback label={'ผู้เรียนทั้งหมด'} className={classes.multipleTitle}>
                    {getFieldDecorator(`multipleStudentPrices[${i}].seats`, {
                      initialValue: priceOp.seats,
                      required: true,
                    })(<InputNumber placeholder="ผู้เรียนทั้งหมด" />)}
                  </FormItem>
                  <FormItem {...formItemLayout} hasFeedback label={'ราคารวม'} className={classes.multiplePrice}>
                    {getFieldDecorator(`multipleStudentPrices[${i}].price`, {
                      initialValue: priceOp.price,
                      required: true,
                    })(<InputNumber placeholder="ราคารวม" />)}
                  </FormItem>
                  <FormItem {...formItemLayout} label={''} className={classes.multiplePrice}>
                    {getFieldDecorator(`multipleStudentPrices[${i}]._id`, {
                      initialValue: priceOp._id,
                    })(<Input type="hidden" placeholder="ราคา Early Bird" />)}
                  </FormItem>
                </div>
              </div>
            ))}
          </div>

          <div className="pull-right">
            <Button type="default" onClick={this.addAdditionalProduct}>
              <Icon type="plus" /> เพิ่มตัวเลือกอื่นๆ
            </Button>
          </div>
          <h2>ตัวเลือกอื่นๆ</h2>
          <div className={classes.additionalSection}>
            {additionalProducts.map((priceOp, i) => (
              <div className={classes.additionalContainer}>
                <div className={'pull-right pointer red'} onClick={() => this.deleteAdditionalProduct(i)}>
                  <Icon type="close" />
                </div>

                <div className={classes.additionalInnerContainer}>
                  <FormItem {...formItemLayout} hasFeedback label={'ชื่อตัวเลือก'} className={classes.additionalTitle}>
                    {getFieldDecorator(`additionalProducts[${i}].title`, {
                      initialValue: priceOp.title,
                      required: true,
                    })(<Input placeholder="" />)}
                  </FormItem>
                  <FormItem {...formItemLayout} hasFeedback label={'คำอธิบายตัวเลือก'} className={classes.additionalDescription}>
                    {getFieldDecorator(`additionalProducts[${i}].description`, {
                      initialValue: priceOp.description,
                      required: true,
                    })(<Input placeholder="" />)}
                  </FormItem>

                  <FormItem {...formItemLayout} hasFeedback label={'ราคา'} className={classes.additionalPrice}>
                    {getFieldDecorator(`additionalProducts[${i}].price`, {
                      initialValue: priceOp.price,
                      required: true,
                    })(<InputNumber placeholder="" />)}
                  </FormItem>
                  <FormItem {...formItemLayout} label={''} className={classes.multiplePrice}>
                    {getFieldDecorator(`additionalProducts[${i}]._id`, {
                      initialValue: priceOp._id,
                    })(<Input type="hidden" placeholder="" />)}
                  </FormItem>
                </div>
              </div>
            ))}
          </div>
          <div className={cn(classes.btnContainer, 'text-center')}>
            <Button type="primary" size="large" onClick={this.handleSubmitPrice} loading={this.props.loading}>
              Save
            </Button>
            <Button type="danger" size="large" onClick={() => this.setState({ isPreview: false })}>
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    );
  }

  render() {
    if (!this.state.masterSchedule) {
      return <div></div>;
    }

    if (this.state.isEditPrice) {
      return <div>{this.renderPriceEditor()}</div>;
    }
    return <div>{this.state.isPreview ? this.renderPreview() : this.renderEditor()}</div>;
  }
}

export default connect((state) => (state) => ({}), {})(Form.create()(MasterScheduleInfoTab));
// \@Form.create()
// @connect(
//   (state) => ({
//     provinces: state.content.contentProvinces,
//     districts: state.content.contentDistricts,
//   }),
//   { editSingleSchedule, editMultipleSchedule, editFlexibleSchedule, getSchedule, getContentDistricts },
// )
